import { cleanObjectFromUndefined } from "@/utils/utils";

export default function updateUrlFilterParams(filters) {
  const copy = { ...filters };
  delete copy.sorting;
  delete copy.page;
  delete copy.pageSize;
  delete copy.filter;

  let urlFilterParams = "";

  for (const [key, value] of Object.entries(cleanObjectFromUndefined(copy))) {
    urlFilterParams += `${key}:${value}_`;
  }

  const params = new URLSearchParams(window.location.search);
  if (urlFilterParams === "") {
    params.delete("filters");
  } else {
    params.set("filters", urlFilterParams);
  }

  if (filters.filter) {
    params.set("q", filters.filter);
  } else {
    params.delete("q");
  }

  if (filters.page) {
    params.set("page", filters.page);
  } else {
    params.delete("page");
  }

  if (filters.pageSize) {
    params.set("pageSize", filters.pageSize);
  } else {
    params.delete("pageSize");
  }

  window.history.replaceState({}, "", `${location.pathname}?${params}`);
}
